export const adminSessionExpiredEvent = "admin-session-expired";

export function signalAdminSessionExpired() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(adminSessionExpiredEvent));
}
